import { render } from "./Panel.vue?vue&type=template&id=0013ef4c&scoped=true&ts=true"
import script from "./Panel.vue?vue&type=script&lang=ts"
export * from "./Panel.vue?vue&type=script&lang=ts"

import "./Panel.vue?vue&type=style&index=0&id=0013ef4c&lang=scss&scoped=true"

import exportComponent from "/buddy/openbanking/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0013ef4c"]])

export default __exports__